import { j as e } from "./jsx-runtime-C5mzlN2N.js";
import x from "styled-components";
import { c as F } from "./clsx.m-BMVuQnLY.js";
import { i as W } from "./isExhaustive-RFXKPwPh.js";
import { A as ne } from "./AvatarLabelGroup-cFBXbwjd.js";
import "./styles-DaQVIHg4.js";
import { T as C } from "./Typography-CGn3dGWy.js";
import { getPaletteForeground as O, getSpacings as N, getRadii as A, getPaletteBackground as S, getPaletteBorder as K, getPaletteBase as M } from "./components/Theme/utils.es.js";
import { createPortal as re } from "react-dom";
import { MenuItem as _, Menu as q, MenuButton as R } from "@headlessui/react";
import { A as oe } from "./Avatar-ydbEbrle.js";
import "./components/Theme/themes.es.js";
import "./palettes-Bw24w7AF.js";
import { useEffect as G, useRef as se, useMemo as ie } from "react";
import "./CssBaseline-Bp4jdUgb.js";
import { I as P } from "./CheckIcon-XCAywhAi.js";
import "./components/Icon/countryVariants.es.js";
import { B as ae } from "./Button-DkQlhrIH.js";
import { u as le } from "./useDisclose-DpzoV9h_.js";
import { u as Q } from "./useAppFloating-C0jAIZYA.js";
import { b as ce, c as de, B as ue } from "./BottomSheet-BBnrYNti.js";
import "./hooks-BmUDB8vC.js";
import { Items as U } from "./components/Dropdown/style.es.js";
import { useMediaQuery as J } from "./components/Theme/hooks.es.js";
import { I as me } from "./IconButton-g0G4rvcV.js";
const pe = x.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  width: 100%;
`, fe = x.div`
  flex: 1;
  text-align: left;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`, T = x.div`
  display: inline-flex;

  color: ${O("quaternary.default")};
`, X = (n) => {
  const {
    text: r,
    shortcut: t,
    leftIcon: o,
    rightIcon: s,
    className: d
  } = n, i = {
    width: 16,
    height: 16
  };
  return /* @__PURE__ */ e.jsxs(pe, { className: d, children: [
    o && /* @__PURE__ */ e.jsx(T, { children: /* @__PURE__ */ e.jsx(
      P,
      {
        ...i,
        ...o
      }
    ) }),
    /* @__PURE__ */ e.jsxs(fe, { children: [
      /* @__PURE__ */ e.jsx(C, { variant: "text", size: "sm", weight: "medium", as: "span", className: "text", children: r }),
      t && /* @__PURE__ */ e.jsx(C, { variant: "text", size: "xs", weight: "regular", as: "span", color: "tertiary", children: t })
    ] }),
    s && /* @__PURE__ */ e.jsx(T, { children: /* @__PURE__ */ e.jsx(
      P,
      {
        ...i,
        ...s
      }
    ) })
  ] });
}, xe = x.button`
  margin: ${N("xxs")} ${N("sm")};

  flex: 1;

  display: flex;
  flex-direction: row;
  align-items: center;

  border-radius: ${A("sm")};

  padding: 9px 10px;

  border: none;

  color: ${O("quaternary.default")};

  background-color: ${S("primary.default")};

  overflow: hidden;

  outline: none;

  background-color: ${(n) => n.$isActive ? S("primary.hover") : "inherit"};

  &:not(.disabled):hover {
    cursor: pointer;
    background-color: ${S("primary.hover")};
  }
  &[data-selected='true'] {
    svg {
      color: ${O("brand.primary.default")};
    }
  }
`, V = (n) => {
  const {
    selected: r,
    disabled: t,
    onClick: o,
    className: s,
    ...d
  } = n, i = F(
    {
      selected: r,
      disabled: t
    },
    s
  );
  return /* @__PURE__ */ e.jsx(_, { disabled: t, children: ({ focus: p }) => /* @__PURE__ */ e.jsx(
    xe,
    {
      onClick: o,
      $isActive: p,
      "data-selected": r,
      className: i,
      children: /* @__PURE__ */ e.jsx(X, { ...d })
    }
  ) });
}, he = x.div`
  display: flex;
  flex-direction: column;
  padding: 4px 0;
    
  &:not(:first-child) {
    border-top: 1px solid ${K("secondary")};
  }
`, ge = (n) => {
  const {
    className: r,
    children: t,
    ...o
  } = n;
  return /* @__PURE__ */ e.jsx(he, { ...o, className: r, children: t });
}, z = x.header`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  
  padding: 12px 16px;

  border-bottom: 1px solid ${K("secondary")};
`, Ue = (n) => {
  switch (n.variant) {
    case "avatar": {
      const {
        variant: r,
        avatar: {
          size: t,
          ...o
        },
        className: s,
        ...d
      } = n;
      return /* @__PURE__ */ e.jsx(z, { ...d, className: F(`variant-${r}`, s), children: /* @__PURE__ */ e.jsx(ne, { ...o, size: t ?? "md" }) });
    }
    case "text": {
      const {
        variant: r,
        text: t,
        className: o,
        ...s
      } = n;
      return /* @__PURE__ */ e.jsx(z, { ...s, className: F(`variant-${r}`, o), children: /* @__PURE__ */ e.jsx(C, { variant: "text", size: "sm", weight: "semibold", as: "span", children: t }) });
    }
    default:
      W(n);
  }
}, be = x(ce)`
  padding: ${N("none")};
`, ve = (n) => {
  const {
    label: r,
    options: t,
    setFloating: o,
    renderOption: s,
    handleSelect: d,
    floatingStyles: i,
    isOptionSelected: p,
    isOpen: m,
    onClose: h
  } = n, b = t.length === 0, I = typeof s < "u", B = J("mobile"), g = b ? /* @__PURE__ */ e.jsx(V, { disabled: !0, text: "No data" }) : /* @__PURE__ */ e.jsx(e.Fragment, { children: t.map(({ label: l, value: c }) => {
    const y = p(c);
    return I ? /* @__PURE__ */ e.jsx(
      _,
      {
        as: "div",
        onClick: (v) => d(v, c),
        children: ({ focus: v }) => s({ label: l, value: c, isSelected: y, isActive: v })
      },
      c
    ) : /* @__PURE__ */ e.jsx(
      V,
      {
        text: l,
        selected: y,
        onClick: (v) => d(v, c),
        rightIcon: y ? { variant: "check" } : void 0
      },
      c
    );
  }) }), f = (l) => {
    const c = l.code === "Escape";
    h && m && c && h();
  };
  return G(() => (window.addEventListener("keydown", f), () => {
    window.removeEventListener("keydown", f);
  }), [m]), B ? /* @__PURE__ */ e.jsxs(de, { isOpen: m, onClose: h, children: [
    typeof r == "string" ? /* @__PURE__ */ e.jsx(ue, { title: r }) : /* @__PURE__ */ e.jsx(e.Fragment, { children: r }),
    /* @__PURE__ */ e.jsx(be, { children: g })
  ] }) : /* @__PURE__ */ e.jsx(e.Fragment, { children: m && /* @__PURE__ */ e.jsx(
    U,
    {
      ref: o,
      static: !0,
      onKeyDown: f,
      style: i,
      "data-options-area": !0,
      children: g
    }
  ) });
}, je = (n) => {
  const {
    currentValue: r,
    selectedValue: t,
    isMultiple: o
  } = n;
  if (!o)
    return t;
  const s = r.split(",").filter((i) => !!i);
  return s.find((i) => i === t) ? [
    ...s
  ].filter((i) => i !== t).join(",") : [
    ...s,
    t
  ].join(",");
}, we = x(ge)`
  &:not(:first-child) {
    border: none;
  }
`, ye = x.input`
  display: none;
`, L = "data-options-area", $e = (n) => {
  const {
    label: r,
    value: t,
    options: o,
    className: s,
    placement: d,
    renderOption: i,
    onChange: p,
    inputRef: m,
    buttonRef: h,
    isMultiple: b,
    isLabelSuffixDisabled: I,
    ...B
  } = n, {
    isOpen: g,
    onClose: f,
    onOpen: l
  } = le(!1), {
    refs: c,
    floatingStyles: y
  } = Q({
    floatingOptions: {
      placement: d,
      open: !1
    }
  }), v = J("mobile"), D = se(null), k = ie(() => {
    if (I)
      return "";
    if (b) {
      const u = [
        ...new Set(t.split(","))
      ];
      if (u.length === 1) {
        const [j] = u, w = o.find(($) => $.value === j);
        return w ? `: ${w.label}` : "";
      }
      if (u.length > 1)
        return ` (${u.length})`;
    }
    const a = o.find((u) => u.value === t);
    return a ? `: ${a.label}` : "";
  }, [
    t,
    o
  ]), Y = (a) => b ? t.split(",").findIndex((j) => j === a) !== -1 : a === t, Z = (a, u) => {
    var w;
    const j = (w = Object.getOwnPropertyDescriptor(
      HTMLInputElement.prototype,
      "value"
    )) == null ? void 0 : w.set;
    if (D.current && j) {
      const $ = je({
        currentValue: t,
        selectedValue: u,
        isMultiple: b
      });
      j.call(D.current, $);
      const E = new Event("input", {
        bubbles: !0
      });
      D.current.dispatchEvent(E);
    }
    b ? a.preventDefault() : f();
  }, ee = () => {
    g ? f() : l();
  };
  return G(() => {
    const a = (u) => {
      var w;
      if (v) return;
      const j = u.button === 0;
      if (g && j) {
        const $ = u.target, E = $.getAttribute(L), te = (w = $.offsetParent) == null ? void 0 : w.getAttribute(L);
        if (E || te)
          return;
        f();
      }
    };
    return window.addEventListener("mousedown", a), () => {
      window.removeEventListener("mousedown", a);
    };
  }, [g, v]), /* @__PURE__ */ e.jsxs(
    q,
    {
      as: we,
      children: [
        /* @__PURE__ */ e.jsx(
          R,
          {
            as: ae,
            className: s,
            ref: (a) => {
              h && (h.current = a), c.setReference(a);
            },
            onClick: ee,
            ...B,
            children: typeof r == "string" ? /* @__PURE__ */ e.jsxs(C, { color: "inherit", size: "sm", weight: "semibold", children: [
              r,
              k
            ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              r,
              k && /* @__PURE__ */ e.jsx(C, { color: "inherit", size: "sm", weight: "semibold", children: k })
            ] })
          }
        ),
        /* @__PURE__ */ e.jsx(
          ye,
          {
            ref: (a) => {
              typeof m == "function" ? m(a) : m && (m.current = a), D.current = a;
            },
            value: t,
            onChange: p
          }
        ),
        /* @__PURE__ */ e.jsx(
          ve,
          {
            label: r,
            isOpen: g,
            onClose: f,
            options: o,
            handleSelect: Z,
            renderOption: i,
            setFloating: c.setFloating,
            floatingStyles: y,
            isOptionSelected: Y
          }
        )
      ]
    }
  );
}, H = x(R)`
  padding: 0;
  border-style: none;
  outline: none;

  background: ${S("primary.default")};

  &:not(.disabled) {
    cursor: pointer;
  }

  &.variant-avatar {
    color: ${M("black")};

    &:hover {
      color: ${M("black")};
    }

    outline: none;
  }

  &.variant-select {
    padding: ${N("md")} ${N("lg")};
    border-radius: ${A("sm")};

    &:hover {
      background: ${S("primary.hover")};
    }
  }

  &.variant-menu {
    border-radius: ${A("full")};
    
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    
    display: flex;
    padding: 10px;
    justify-content: center;
    align-items: center;
    
    &:hover {
      box-shadow: 0 0 0 4px rgba(152, 162, 179, 0.14);
    }
  }

  width: ${(n) => n.$isFullWidth ? "100%" : ""};
`, Je = (n) => {
  const {
    variant: r,
    disabled: t,
    children: o,
    className: s,
    fullWidth: d,
    placement: i = "bottom-end"
  } = n, {
    refs: p,
    floatingStyles: m
  } = Q({
    floatingOptions: {
      placement: i
    }
  }), h = F(`variant-${r}`, s), b = (l) => {
    const {
      size: c = "md",
      ...y
    } = l.avatarProps;
    return /* @__PURE__ */ e.jsx(
      H,
      {
        ref: p.setReference,
        className: h,
        disabled: t,
        children: /* @__PURE__ */ e.jsx(oe, { size: c, ...y })
      }
    );
  }, I = (l) => /* @__PURE__ */ e.jsx(
    H,
    {
      className: h,
      ref: p.setReference,
      $isFullWidth: d,
      disabled: t,
      children: /* @__PURE__ */ e.jsx(X, { ...l.selectProps })
    }
  ), B = (l) => /* @__PURE__ */ e.jsx(
    $e,
    {
      placement: i,
      ...l.filterSelectProps
    }
  ), g = (l) => {
    const c = {
      variant: "outlined",
      color: "gray",
      ...l.iconButtonProps
    };
    return /* @__PURE__ */ e.jsx(
      R,
      {
        ...c,
        ref: p.setReference,
        as: me,
        children: /* @__PURE__ */ e.jsx(P, { variant: l.iconVariant })
      }
    );
  }, f = () => {
    switch (r) {
      case "avatar":
        return b(n);
      case "select":
        return I(n);
      case "filter":
        return B(n);
      case "icon":
        return g(n);
      default:
        W(r);
    }
  };
  return /* @__PURE__ */ e.jsxs(q, { children: [
    f(),
    r === "filter" ? void 0 : /* @__PURE__ */ e.jsx(e.Fragment, { children: re(
      /* @__PURE__ */ e.jsx(
        U,
        {
          ref: p.setFloating,
          style: m,
          $isFullWidth: d,
          children: o
        }
      ),
      document.body
    ) })
  ] });
};
export {
  V as D,
  ge as a,
  Ue as b,
  Je as c,
  $e as d,
  X as e
};
